//Custom Element Register
if (!customElements.get('rxc-activator')) {
  class RXCActivator extends HTMLElement {
    constructor() {
      super();
      this.singletonCheck();
      this.activatorBtn = null;
      this.isLoading = false;
      this.shopUrl = null;
      this.proxyPath = null;
      this.rxcFrameId = null;
      this.rxcFrameTitle = null;
      this.rxcErrorMsg = null;
      this.selectedVariantAvailable = this.dataset.variantAvailable;
      console.log('[Shopify RXCActivator] Init - Mounting');
      this.activatorBtn = this.querySelector("[name='rxc-activator']");
      this.addToBagBtn = document.querySelector(`#ProductSubmitButton-${this.dataset.sectionId}`) ? document.querySelector(`#ProductSubmitButton-${this.dataset.sectionId}`) : null;
    }

    connectedCallback() {
      document.addEventListener("prescription-lenses-click", () => {
        this.activatorBtn?.click();
      })

      // If variant is not available do nothing
      //   commented to fix issue with CTAs when page is loaded with OOS variant and then user select an available one
      // if (this.selectedVariantAvailable == 'false') {
      //  return;
      // }

      this.checkMocoAvailability();

      // Show button when location changed
      subscribe(PUB_SUB_EVENTS.faceSizeSelection, (eventData) => {

        this.setAttribute('data-variant-available', eventData.data.variant.available);
        this.selectedVariantAvailable = eventData.data.variant.available;

        if(this.isVariantAvailable(eventData.data.variant.available) == false) {
          // If variant is not available hide rxc button
          this.displayPrescriptionCta(false);
          return;
        } else {
          console.log("variant change - checking MoCo availability");
          this.displayPrescriptionCta(true);
          this.checkMocoAvailability();
        }

      });
    }

    // Check if selected variant is available
    isVariantAvailable(variantAvailable){
      return variantAvailable === true || variantAvailable === 'true';
    }

    checkMocoAvailability() { 
      const market = this.activatorBtn.getAttribute('data-market');
  
      // Estrai e normalizza l'handle
      const urlSlices = window.location.pathname.split('/');
      const productHandle = urlSlices[urlSlices?.length - 1];
      const [modelCode, colorCode] = productHandle.split('-');
      const adaptedModelCode = modelCode.toUpperCase();
      const adaptedMoCo = modelCode.toUpperCase() + '__' + colorCode.toUpperCase();

      // Local variables
      const BASE_URL = 'https://assets.persol.com/extra/image/rxcbe';
      const ENVIRONMENT = this.dataset.env;
      const BRAND_CODE = 'PO';

      this.fetchAvailability(
        BASE_URL,
        ENVIRONMENT,
        BRAND_CODE,
        market,
        adaptedModelCode,
        adaptedMoCo
      );
    }

    fetchAvailability(BASE_URL, ENVIRONMENT, BRAND_CODE, market, adaptedModelCode, adaptedMoCo) {
      let isMocoAvailable = false;
      let isModelAvailable = false;

      fetch(`${BASE_URL}/${ENVIRONMENT}/availability/${BRAND_CODE}/${market}/availability_${adaptedModelCode}.json`)
        .then(res => res.json())
        .then(res => {
          isMocoAvailable = res[adaptedMoCo]?.availability === true ? true : false;
          isModelAvailable = Object.keys(res).some(key => key.startsWith(adaptedModelCode + '__'));

          if (isMocoAvailable && isModelAvailable) {
            console.log("RXC - MoCo is available");
            this.displayPrescriptionCta(true);
            if(this.dataset.productType == "optical") {
              this.removeExpressCheckout();
              this.displayAddToBagCta(false);
            }
            this.activatorBtn.setAttribute('data-is-available', 'true');
          } else {
            console.log("RXC - MoCo is NOT available");
            this.displayAddToBagCta(true);
            this.displayPrescriptionCta(false);
          }

          if (isMocoAvailable) {
            this.isLoading = false;
            this.shopUrl = window.Shopify?.shop + window.Shopify.routes.root;
            this.proxyPath = market === 'US' ? 'rxc-us' : 'rxc';
            this.rxcFrameId = this.dataset.rxcFrameId || 'rxc-iframe';
            this.rxcFrameTitle = this.dataset.rxcFrameTitle || 'RXC - Lens Configurator';
            this.rxcErrorMsg = this.dataset.rxcErrorMsg || 'Error RXC Loading - Try later';

            window.addEventListener('message', this.window_messageHandler);
            this.activatorBtn?.addEventListener('click', this.activator_clickHandler);

            const searchParams = new URLSearchParams(window.location.search);

            let rxcUrlContext = {
              isEditLenses: searchParams.get('isEditLenses') === 'true',
              isAddLenses: searchParams.get('isAddLenses') === 'true',
              frameUniqueId: searchParams.get('frameUniqueId'),
              lensUniqueId: searchParams.get('lensUniqueId'),
              orderItemId: searchParams.get('orderItemId'),
              frameSize: searchParams.get('size'),
              fromWishlist: searchParams.get('rxc-wishlist') === 'true',
              rxcnav: searchParams.get('rxcnav')
            };

            const isEditingContext =
              rxcUrlContext.isEditLenses && rxcUrlContext.frameUniqueId && rxcUrlContext.lensUniqueId && rxcUrlContext.orderItemId;
            const isAddContext = rxcUrlContext.isAddLenses && rxcUrlContext.frameUniqueId;
            const fromWishlist = rxcUrlContext.fromWishlist;
            const isRxcNavContext = Boolean(rxcUrlContext.rxcnav);

            if (isEditingContext || isAddContext) {
              console.log('isEditingContext || isAddContext');
              
              this.setLoading(true);
              this.showFrame(rxcUrlContext);
            }

            if (fromWishlist) {
              console.log('fromWishlist');

              this.setLoading(true);
              this.showFrame(rxcUrlContext);
            }

            if (isRxcNavContext && !isEditingContext && !isAddContext && !fromWishlist) {
              this.setLoading(true);
              this.showFrame(rxcUrlContext);
            }
          }
        })
        .catch(error => {
          this.displayPrescriptionCta(false);
          this.activatorBtn.style.display = 'none';
          this.displayAddToBagCta(true);
          this.activatorBtn.setAttribute('data-is-available', 'false');
        });
    }

    removeExpressCheckout() {
      const expressCheckout = document.querySelector(`.express-checkout-form`);
      if (expressCheckout) expressCheckout.style.display = "none";
    }

    displayPrescriptionCta(display) {
      document.querySelectorAll(".prescription-cta-link").forEach((cta) => cta.style.display = display ? "" : "none");
    }

    displayAddToBagCta(display) {
      if (this.addToBagBtn) this.addToBagBtn.setAttribute('data-display-cta-based-on-rxc', display ? 'true' : 'false');
    }

    getTealiumTrackingContext(item = {}) {
      const dataset = this.addToBagBtn?.dataset || {};
      let productData = null;

      if (dataset.trackingProduct) {
        try {
          productData = JSON.parse(dataset.trackingProduct);
        } catch (_error) {
          productData = null;
        }
      }

      return {
        productHandle: dataset.handle || item.handle || '',
        variantSku: dataset.sku || dataset.description || item.sku || '',
        productId: dataset.trackingProductId || item.product_id || '',
        variantId: String(item.id || dataset.variantId || ''),
        productData
      };
    }

    async publishRxcCartUpdate(response, item = {}) {
      if (typeof publish !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
        return;
      }

      const trackingContext = this.getTealiumTrackingContext(item);
      const cartData = Array.isArray(response?.items)
        ? { items: response.items }
        : Array.isArray(response)
          ? { items: response }
          : response;

      await publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'rxc-integration',
        productVariantId: trackingContext.variantId,
        cartData,
        productHandle: trackingContext.productHandle,
        variantSku: trackingContext.variantSku,
        productId: trackingContext.productId,
        variantId: trackingContext.variantId,
        productData: trackingContext.productData,
        units: item.quantity || 1
      });
    }

    normalizeRxcProductsForTealium(payload = {}) {
      if (!payload?.products || typeof payload.products !== 'object') {
        return null;
      }

      const fallbackUnits = String(
        payload.quantity ??
        payload.item?.quantity ??
        1
      );

      return Object.entries(payload.products).reduce((acc, [productKey, productData]) => {
        if (!productData || typeof productData !== 'object') {
          return acc;
        }

        const nextProductData = { ...productData };

        if (!('Status' in nextProductData)) {
          nextProductData.Status = nextProductData.status || 'Available';
        }

        if (
          (nextProductData.Units === undefined || nextProductData.Units === null || nextProductData.Units === '') &&
          fallbackUnits
        ) {
          nextProductData.Units = fallbackUnits;
        }

        delete nextProductData.status;
        acc[productKey] = nextProductData;
        return acc;
      }, {});
    }

    onRXCUpdatedCart(payload) {
      const products = this.normalizeRxcProductsForTealium(payload);

      if (
        products &&
        Object.keys(products).length > 0 &&
        typeof window.sendTealiumEvent === 'function'
      ) {
        window.sendTealiumEvent({
          id: 'Event',
          Events_CartAdd: '1',
          Products: products
        });
      }

      window.location = window.routes.cart_url;
    }

    disconnectedCallback() {
      // console.log('[Shopify RXCActivator] Unmounting');
      window.removeEventListener('message', this.window_messageHandler);
      this.activatorBtn?.removeEventListener('click', this.activator_clickHandler);
    }

    singletonCheck() {
      if (document.getElementsByTagName('rxc-activator').length > 1) {
        console.error('Multiple instances of <rxc-activator> detected. Only one instance is allowed.');
        return false;
      }
      return true;
    }
  
    setLoading(isLoading) {
      if (this.activatorBtn) {
        this.activatorBtn.toggleAttribute('data-loading', isLoading);
        this.activatorBtn.ariaDisabled = isLoading;
        this.activatorBtn.disabled = isLoading;
      }
  
      this.isLoading = isLoading;
    }
  
    activator_clickHandler = evt => {
      evt.preventDefault();
  
      if (!this.shopUrl) {
        console.error('Shop URL not found');
        return;
      }
  
      if (!this.isLoading) {
        this.setLoading(true);
        this.showFrame();
      }
    };
  
    showFrame(rxcUrlContext = {}) {
      this.nestedInfo = this.checkNestedProducts();

      const urlParams = new URLSearchParams(window.location.search);
  
      const variantId = urlParams.get('variant') || this.activatorBtn.getAttribute('data-variant-id');
      const country = this.activatorBtn.getAttribute('data-market');
      const market = this.activatorBtn.getAttribute('data-market-id');
      const language = this.activatorBtn.getAttribute('data-language');
      const currency = this.activatorBtn.getAttribute('data-currency');
  
      const iframeUrl = new URL(`${window.location.protocol}//${this.shopUrl}/apps/${this.proxyPath}/prescription/index`);
      const iframe = document.getElementById(this.rxcFrameId) || document.createElement('iframe');
  
      if (rxcUrlContext && Object.keys(rxcUrlContext)?.length) {
        const isEditingContext =
          rxcUrlContext.isEditLenses && rxcUrlContext.frameUniqueId && rxcUrlContext.lensUniqueId && rxcUrlContext.orderItemId;
        const isAddContext = rxcUrlContext.isAddLenses && rxcUrlContext.frameUniqueId && rxcUrlContext.orderItemId;
  
        if (isAddContext) {
          console.log('isAddContext');
          
          iframeUrl.searchParams.set('isAddLenses', 'true');
          iframeUrl.searchParams.set('frameUniqueId', rxcUrlContext.frameUniqueId);
          iframeUrl.searchParams.set('orderItemId', rxcUrlContext.orderItemId);
          iframeUrl.searchParams.set('rxc_cart_manual_add_frame_enabled', 'true');
        }
  
        if (isEditingContext) {
          console.log('isEditingContext');
          
          iframeUrl.searchParams.set('isEditLenses', 'true');
          iframeUrl.searchParams.set('frameUniqueId', rxcUrlContext.frameUniqueId);
          iframeUrl.searchParams.set('lensUniqueId', rxcUrlContext.lensUniqueId);
          iframeUrl.searchParams.set('orderItemId', rxcUrlContext.orderItemId);
        }

        if (rxcUrlContext.rxcnav) {
          iframeUrl.searchParams.set('rxcnav', rxcUrlContext.rxcnav);
        }
      }
  
      iframeUrl.searchParams.set('variantId', variantId);
      iframeUrl.searchParams.set('market', country);
      iframeUrl.searchParams.set('market_id', market);
      iframeUrl.searchParams.set('language', language);
      iframeUrl.searchParams.set('currency', currency);
      
      if (this.nestedInfo.hasNested){
        iframeUrl.searchParams.set('rxc_cart_manual_add_frame_enabled', true);
      }
  
      iframe.id = this.rxcFrameId;
      iframe.title = this.rxcFrameTitle;
      iframe.tabIndex = -1;
      iframe.src = iframeUrl.toString();
  
      iframe.onerror = () => {
        console.error('RXC App Embed Error');
        this.onRXCError();
      };
  
      iframe.toggleAttribute('data-loading', true);
      document.body.appendChild(iframe);
    }
  
    onFrameLoaded() {
      const rxcAppEmbed = document.getElementById(this.rxcFrameId);
      this.setLoading(false);
      publish("frame-loaded", {});
  
      if (!rxcAppEmbed) {
        console.error('RXC App Embed not found');
        return;
      }
  
      rxcAppEmbed.toggleAttribute('data-loading', false);
      rxcAppEmbed.toggleAttribute('data-ready', true);
    }
  
    onRXCError() {
      let messageTemplate = this.querySelector('p[data-rxc-error]') || document.createElement('p');
      messageTemplate.setAttribute('data-rxc-error', true);
      messageTemplate.textContent = this.rxcErrorMsg;
      this.activatorBtn.insertAdjacentElement('afterend', messageTemplate);
      this.setLoading(false);
    }
  
    window_messageHandler = event => {
      const rxcAppData = event?.data?.rxcApp;
  
      if (!rxcAppData) return;
  
      switch (rxcAppData.type) {
        case 'RXC_IS_ON_ERROR':
          console.log('RXC_IS_ON_ERROR RECEIVED:', event.data);
          this.onRXCError();
          break;
        case 'RXC_LOADED':
          console.log('[Shopify RXCActivator] Message from RXC APP:', event.data);
          this.onFrameLoaded();
          break;
        case 'RXC_FRAME_ONLY_ADDED_TO_CART':
          console.log('RXC_FRAME_ONLY_ADDED_TO_CART', event.data);
          const searchParams = new URLSearchParams(window.location.search);
          const isAddContext = searchParams.get('rxc_cart_manual_add_frame_enabled') === 'true';
          if (isAddContext) {
            Promise.resolve(this.publishRxcCartUpdate(rxcAppData.payload, rxcAppData.payload))
              .finally(() => {
                window.location = window.routes.cart_url;
              });
          } else {
            this.handleManualAddFrameWithNested(event.data.rxcApp.payload, this.nestedInfo);
          }
          break;
        case 'RXC_UPDATED_CART':
          this.onRXCUpdatedCart(rxcAppData.payload);
          break;
      }
    };

    /**
     * Checks if the product has nested items that must be added to cart together
     * with the main product (for now only monogram).
     *
     * It looks for hidden inputs inside the product form that represent
     * nested cart items and save the input elements for later use.
     *
     * @returns {Object} result
     */
    checkNestedProducts() {
      let inputs = document.querySelectorAll('product-form form input.js-nested-cart-item');

      const result = {
        hasNested: false,
        hasMonogram: false,
        monogramItem: null
      };
      
      // If no nested inputs are found, return default values
      if (!inputs.length) return result;

      result.hasNested = true;

      // Loop through nested inputs to identify specific nested products
      inputs.forEach(input => {
        const name = input.name || '';

        // Detect monogram nested product
        if (name == 'monogram-input') {
          result.hasMonogram = true;
          result.monogramItem = input;
        }
      });

      return result;
    }

    /**
     * Manually builds the payload to add a frame product to cart
     * together with its nested products (e.g. monogram).
     *
     * This method is triggered when RXC_FRAME_ONLY_ADDED_TO_CART 
     * and manually handle the cart addition.
     *
     * @param {Object} item - Frame item data coming from RXC
     * @param {Object} nestedItems - Result object from checkNestedProducts()
     */
    handleManualAddFrameWithNested(item, nestedItems) {
      const properties = item.properties || {};
      const lineItemProperties = {
        ...properties,
        _status: properties._status || 'Available'
      };
      const items = [];

      // Add main frame product
      items.push({
        'id': item.id,
        'quantity': item.quantity || 1,
        properties: lineItemProperties
      });

       // If a monogram is present, add it as a nested cart item
      if (nestedItems.hasMonogram == true) {
        this.handleManualMonogramNested(item, items, nestedItems.monogramItem)
      }

      // Payload structure expected by Shopify cart/add.js
      let formData = {
        items
      };

      // Manual add to cart
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then((response) => response.json())
      .then(async (response) => {
        if (response.status) {   
          alert('Error adding to cart')       
        } else {
          await this.publishRxcCartUpdate(response, item);
          window.location = window.routes.cart_url;
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
      
    }

    /**
     * Adds a monogram product as a nested cart item linked to the parent frame.
     *
     * The monogram item is added with custom properties that associate it
     * to the parent frame product.
     *
     * @param {Object} parentItem - Frame item added to cart
     * @param {Array} itemsObject - Items array to be sent to cart/add.js
     * @param {HTMLElement} monogramItem - Input element containing monogram data
     */
    handleManualMonogramNested(parentItem, itemsObject, monogramItem) {

      itemsObject.push({
        id: monogramItem.dataset.monogramVariantId,
        quantity: 1,
        properties: {
          monogram_text: monogramItem.dataset.monogramText,
          monogram_font: monogramItem.dataset.monogramFont,
          monogram_parent_id: parentItem.id
        },
        parent_id: parentItem.id,
      });
    }

  }

  customElements.define('rxc-activator', RXCActivator);
}
